import React, { useState, useEffect, useRef } from "react";
import Layout from "./layout";
import { useNavigate } from "react-router-dom";

import MetricCard from "../components/MetricCard";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "../components/DataTable";
import DateInput from "../components/DateInput";
import Button from "../components/Button";
import TextInput from "../components/TextInput";
import CustomerData from "../assets/json/customermanagement.json";
import CustomerIcon from "../assets/svg/CustomerIcon.svg";
import ActiveCustomerIcon from "../assets/svg/ActiveCustomerIcon.svg";
import CustomerRate from "../assets/svg/CustomerRate.svg";
import CustomerValue from "../assets/svg/CustomerValueIcon.svg";
import UndoIcon from "../assets/svg/undo.svg";
import RedoIcon from "../assets/svg/redo.svg";
import TemplateIcon from "../assets/svg/Template.svg";
import FilterIcon from "../assets/svg/filter.svg";
import VerticalLine from "../assets/svg/VerticalLine.svg";


const Customer = () => {
    const navigate = useNavigate();
    // ✅ Refresh page
    const handleRefresh = () => {
        window.location.reload(); // This will refresh the page
    };
    const handleTextInputChange = (value) => {
        console.log("TextInput:", value);
    };

    const columns = [
        { headname: "ID", type: "text", dbcol: "col1" },
        { headname: "CUSTOMER NAME", type: "text", dbcol: "col2" },
        { headname: "EMAIL ID", type: "text", dbcol: "col3" },
        { headname: "PHONE NUMBER", type: "text", dbcol: "col4" },
        { headname: "ORDER PLACED", type: "", dbcol: "col5" },
        { headname: "TOTAL SPEND", type: "", dbcol: "col6" },
        { headname: "END DATE", type: "time", dbcol: "col7" },
        { headname: "STATUS", type: "badge", dbcol: "col8" },
    ];

    return (
        <Layout>

            <div className="d-flex align-items-center justify-content-between">

                <div className="mt-3 d-flex align-items-center">
                    <div className="d-flex gap-5 md-date">
                        <DateInput label="" type="range" includeTime={false} />
                    </div>

                    {/* Refresh Button */}
                    <div className=" mb-2 ps-3 md-refresh ">
                        <i
                            className="bi bi-arrow-repeat icon-refresh"
                            onClick={handleRefresh}
                        ></i>
                    </div>
                </div>

                <div className="text-right gap-3 ie-btn d-flex">
                    <Button buttonType="import" label="Import" />
                    <Button buttonType="export" label="Export" />
                    <div className="dropdown">
                        <Button
                            buttonType="add"
                            onClick={() => navigate("/add-customer")}
                            label="Create New"
                        />
                    </div>
                </div>
            </div>

            <div className="card-container gap-4 flex-wrap">
                <Row className="metrix-container">
                    <Col xs={4} md={3}>
                        <MetricCard
                            title="Total Customer"
                            operation="count"
                            column="col1"
                            jsonData={CustomerData}
                            icon={CustomerIcon} // You can change this to any Bootstrap icon name like "check-circle", "database", etc.
                            tooltipText="This shows the count of live blogs" // Tooltip for additional context
                        />
                    </Col>
                    <Col xs={4} md={3}>
                        <MetricCard
                            title="Active Customer"
                            operation="count"
                            column="col2"
                            jsonData={CustomerData}
                            icon={ActiveCustomerIcon}// You can change this to any Bootstrap icon name like "check-circle", "database", etc.
                            tooltipText="This shows the count of Draft Blog" // Tooltip for additional context
                        />
                    </Col>
                    <Col xs={4} md={3}>
                        <MetricCard
                            title="Churn Rate"
                            operation="count"
                            column="col4"
                            jsonData={CustomerData}
                            icon={CustomerRate} // You can change this to any Bootstrap icon name like "check-circle", "database", etc.
                            tooltipText="This shows the total of Views" // Tooltip for additional context
                        />
                    </Col>
                    <Col xs={4} md={3}>
                        <MetricCard
                            title="Average Lifetime Value"
                            operation="count"
                            column="col2"
                            jsonData={CustomerData}
                            icon={CustomerValue} // You can change this to any Bootstrap icon name like "check-circle", "database", etc.
                            tooltipText="This shows the total of Users" // Tooltip for additional context
                        />
                    </Col>
                </Row>
            </div>
            <br></br>
            <div className="segment-header">
                <div className="segment-header-child">
                    <div className="input-section ">
                        <TextInput
                            placeholder="Segment Name"
                            onChange={handleTextInputChange}
                            className="segment-input"
                        />
                    </div>
                    <div className="segmentBar-btn">
                        <button className="segmentBar-iconBtn">
                            <img src={UndoIcon} alt="Undo" />
                        </button>

                        <button className="segmentBar-iconBtn">
                            <img src={RedoIcon} alt="Redo" />
                        </button>
                        <p>Templates</p>
                        <img src={TemplateIcon} alt="Template" className="segmentBar-icon mt-1" />
                        <img src={VerticalLine} className="vertical"/>
                        <p>Filters</p>
                        <img src={FilterIcon} alt="Filter" className="segmentBar-icon mt-1" />
                    </div>
                </div>

                {/* Instruction */}
                <p className="segment-instruction">
                    To create a segment, choose a <a href="#">template</a> or apply a{" "}
                    <a href="#">filter</a>.
                </p>

                {/* Save Button */}
                <div className="segment-save">
                    <button className="save-btn">Save Segment</button>
                </div>
            </div>


            <DataTable
                id="table1"
                columns={columns}
                data={CustomerData}
                defaultView="table"
                searchable={true}
                filterable={true}
                sortable={true}
                paginated={true}
            />
        </Layout>
    );
}
export default Customer;